exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-context-menu-item {\n  position: relative;\n  list-style: none;\n  padding: 9px 14px;\n  color: #000000;\n}\n.uu5-bricks-context-menu-item:hover {\n  background-color: #FAFAFA;\n}\n.uu5-bricks-context-menu-item.uu5-common-disabled {\n  background-color: lightgrey;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/context-menu-item.less
// module id = 200
// module chunks = 0